<mat-card>
	<mat-card-title id="PAY_CATEGORY_DETAILS_TITLE">Details</mat-card-title>
	<hr />
	<mat-card-content class="card-content">
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					required
					matInput
					placeholder="Name"
					id="PAY_CATEGORY_NAME"
					name="name"
					[disabled]="isArchived"
					[(ngModel)]="payCategory.name"
					maxLength="100"
					(ngModelChange)="isNeedChange()"
					#characterCountHintExample
				/>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					name="shortcode"
					id="PAY_CATEGORY_SHORTCODE"
					required
					matInput
					[disabled]="isArchived"
					[(ngModel)]="payCategory.shortCode"
					placeholder="Short Code"
					maxLength="10"
					(ngModelChange)="isNeedChange()"
					#characterCountHintExample
				/>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<!-- // Hours, Count, Dollars, Days, -->
				<mat-select
					id="PAY_CATEGORY_UNIT"
					name="unit"
					required
					placeholder="Unit"
					[disabled]="isArchived"
					[(ngModel)]="payCategory.unit"
					(ngModelChange)="isNeedChange()"
				>
					<mat-option *ngFor="let item of ['Hours', 'Count', 'Dollars', 'Days']" [value]="item">
						{{ item }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</mat-card-content>
</mat-card>
